import React from "react";
import './card-style.css'

function CardInfo(props) {
    return (
        <div className="container-cards">
            {props.data.map((item, index) => (
                <div className="item" key={index}>
                    <h4 className="chave">{item.name}</h4>
                    <p className="valor">{item.value}</p>
                </div>
            ))}
        </div>
    );
}

export default CardInfo;
